import { z } from 'zod';
import { transformAndFilterValidEdges } from '../../../common/tools/transformEdgesUtils';
import { BaseResourceLibraryItemSchema } from './resourceLibraryBaseZodSchemas';
import { ImageSchema } from '../../../common/schemas/imageZodSchemas';

const NavigationNodeSchema = z
    .object({
        id: z.string(),
    })
    .describe('NavigationNodeSchema');

const ContentSectionSchema = z
    .object({
        level: z.number().min(0),
        title: z.string().nullable(),
        content: z.string().nullable(),
    })
    .describe('ContentSectionSchema');

export const ResourceLibraryArticleBaseItemSchema = BaseResourceLibraryItemSchema.extend({
    lastModificationDate: z.string().nullable(),
}).describe('ResourceLibraryArticleBaseItemSchema');

export const ResourceLibraryArticleItemSchema = ResourceLibraryArticleBaseItemSchema.extend({
    coverImage: ImageSchema.nullable(),
    sections: z.array(ContentSectionSchema),
    navigationNode: NavigationNodeSchema.nullable(),
}).describe('ResourceLibraryArticleItemSchema');

// Listing query returns basse article items (without 'body' field)
export const GetResourceLibraryArticleItemListingSchema = z
    .object({
        getResourceLibraryArticleItemListing: z.object({
            edges: z
                .array(
                    z.object({
                        node: z.unknown(),
                    })
                )
                .transform((edges) =>
                    transformAndFilterValidEdges(ResourceLibraryArticleBaseItemSchema, edges)
                ),
        }),
    })
    .describe('GetResourceLibraryArticleItemListingSchema');

// Single item query returns full article items (with 'body' field)
export const GetResourceLibraryArticleItemSchema = z
    .object({
        getResourceLibraryArticleItem: ResourceLibraryArticleItemSchema,
    })
    .describe('GetResourceLibraryArticleItemSchema');
